// Access denied view - shown when the user is authenticated via d3-auth
// but doesn't have access to the RPGish API (403 from backend).

import { css, html } from 'lit';
import { authState, logout } from '../../lib/auth.js';
import { BaseComponent } from '../../lib/base-component.js';

// ShieldX icon SVG
const shieldXIcon = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="64"
  height="64"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
  <line x1="9.5" x2="14.5" y1="9" y2="14" />
  <line x1="14.5" x2="9.5" y1="9" y2="14" />
</svg>`;

class AccessDeniedView extends BaseComponent {
  static styles = css`
    :host {
      display: block;
      flex: 1;
    }

    .access-denied-view {
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
      background-color: #f8f9fa;
    }
  `;

  render() {
    const name = authState.user?.preferred_username || authState.user?.name || authState.user?.email || 'your account';

    return html`
      <div class="access-denied-view">
        <div class="text-center">
          <div class="text-danger mb-3">${shieldXIcon}</div>
          <h1 class="h3 mb-3">Access Denied</h1>
          <p class="text-muted mb-2">
            You're signed in as <strong>${name}</strong>, but this account doesn't have access to RPGish.
          </p>
          <p class="text-muted mb-4">
            If you believe this is a mistake, contact the RPGish team to request access.
          </p>
          <button class="btn btn-outline-secondary" @click="${this._handleSignOut}">Sign Out</button>
        </div>
      </div>
    `;
  }

  _handleSignOut() {
    logout();
  }
}

customElements.define('access-denied-view', AccessDeniedView);
